import React, { useRef } from "react";
import Layout from "../Layout";
import MusicPlayer from "../MusicPlayer";
import { RiPlayMiniFill } from "react-icons/ri";
import Playlist_Card from "./LibraryComponents/Playlist_Card";
import { playList, songs } from "../../database/song";
export default function Library() {
  const playPause = useRef();

  const showPlayPause = () => {
    playPause.current.style.opacity = 1;
    playPause.current.style.transform = "translateY(-36px)";
  };
  const unShowPlayPause = () => {
    playPause.current.style.opacity = 0;
    playPause.current.style.transform = "translateY(0px)";
  };

  return (
    <>
      <Layout isLibrary={true} />
      <div className="pl-64 pt-20 w-screen pb-32">
        <h4 className="text-white text-xl font-semibold">Playlists</h4>
        <div className="pt-4 flex">
          <div
            onMouseOver={showPlayPause}
            onMouseOut={unShowPlayPause}
            className="w-[480px] h-[300px] mr-4 rounded-lg relative cursor-pointer hover:opacity-100 opacity-90 transition-all ease-in"
            style={{
              backgroundImage: "linear-gradient(#0d72ea, #9198e5)",
            }}
          >
            <div className="absolute bottom-6 left-6">
              <h2 className="text-3xl font-bold text-blue-100">Liked Songs</h2>
              <p className="text-lg  text-blue-100">0 liked songs</p>
            </div>
            <div
              ref={playPause}
              className="w-12 h-12  rounded-full  bg-[#1fdf64] hover:bg-[#63e894] opacity-0 absolute right-6 bottom-2  transition-all ease-in-out flex items-center justify-center duration-300"
            >
              <RiPlayMiniFill className="text-black text-3xl   rounded-full " />
            </div>
          </div>
          <div className="w-[240px] h-[300px] rounded-lg relative cursor-pointer hover:opacity-100 opacity-90 transition-all ease-in bg-[#2f2f2f] flex flex-col  justify-between p-4">
            <div
              style={{
                width: "100%",
                height: "80%",
                backgroundColor: "#464646",
                borderRadius: 8,
              }}
            >
              <img
                src={require("../../assets/playlist_thumb/musicnote.png")}
                alt="Music Note"
              />
            </div>
            <div className="">
              <h2
                style={{
                  fontSize: 18,
                  marginTop: 8,
                  color: "white",
                }}
              >
                Liked Songs
              </h2>
              <p
                style={{
                  fontSize: 12,
                  opacity: 0.6,
                  color: "white",
                }}
              >
                0 liked songs
              </p>
            </div>
          </div>
        </div>
        <h4 className="text-white text-xl font-semibold mt-8">
          Best of Movies
        </h4>
        <div className="flex flex-wrap ">
          {playList.map((data) => (
            <Playlist_Card data={data} key={data._id} />
          ))}
        </div>
        {/* <div className="flex flex-wrap ">
          {songs
            .filter((song) => song.movie != "")
            .map((data) => (
              <Lib_Card
                thumbnail={data.singerThumb}
                artistName={data.singer}
                type="artist"
                movie={data.movie}
                key={data._id}
              />
            ))}
        </div> */}
      </div>
      {/* <MusicPlayer /> */}
    </>
  );
}
